export const treeCheckThemes = {
  transparent: 'transparent',
  gray: 'gray',
};
